import { render, staticRenderFns } from "./modalNewCertificate.vue?vue&type=template&id=7a38231d"
import script from "./modalNewCertificate.vue?vue&type=script&lang=js"
export * from "./modalNewCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports